module["exports"] = [
  "מדינת ישראל"
];
